import styled from '@emotion/styled'

export const StyledWrapper = styled.div`
  .ant-typography-danger {
    color: #ec4949;
    font-size: 12px;
  }
`
